import { createReducer, on } from '@ngrx/store';
import { GetRolesFailed, GetRolesSuccess } from '../actions/roles.actions';

export interface RolesState {
  roles: any;
  loaded: boolean;
}

const initialState: RolesState = {
  roles: {},
  loaded: false,
};

export const RolesReducer = createReducer(
  initialState,
  on(GetRolesSuccess, (state, { roles }) => ({
    ...state,
    roles: typeof roles === 'string' ? JSON.parse(roles) : roles?.userPermissions || roles,
    loaded: true,
  })),
  on(GetRolesFailed, (state) => ({
    ...state,
    loaded: true,
  })),
);
